import baseRequest from "../_core/baseRequest";

export default {
    getShiftRequest: params => baseRequest.post("/shifts/request/list", params),
    createShiftRequest: params => baseRequest.post("/shifts/request", params),
    deleteShiftRequest: params => baseRequest.post("/shifts/request/delete", params),
    updateShiftRequest: params => baseRequest.post("/shifts/request/update", params),
    updateShiftRequestByOperation: params => baseRequest.post("/shifts/request/update-by-operation", params)
};
